import analytics from "web/script/analytics/analytics";
import requester from "web/script/modules/requester";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { openCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";
import Button from "web/react/components/button/button";
import browser from "web/script/utils/browser";
import { BranchIOLinkData, BranchLink, getLinkData } from "web/script/utils/branch-io";
import environment from "web/script/modules/environment";
import { useClickTracker } from "web/react/hooks/use-click-tracker/use-click-tracker";

interface FollowDesignerButtonProps {
    lystId: number;
    registrationReason?: string;
    followedText: string;
    notFollowedText: string;
    isAuthenticated: string;
    isFollowing: string;
    openCustomerCaptureOverlay: (object) => void;
    analyticsParameters: [string, string, string];
    className: string;
}

export function FollowDesignerButton({
    lystId,
    registrationReason,
    followedText,
    notFollowedText,
    isAuthenticated,
    isFollowing,
    openCustomerCaptureOverlay,
    analyticsParameters,
    className,
}: FollowDesignerButtonProps): JSX.Element {
    const [following, setFollowing] = useState<boolean>(isFollowing != "false");
    const [isIos, setIsIos] = useState(false);

    useEffect(() => {
        setIsIos(browser.ios);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [browser.ios]);

    function follow(): Promise<void> {
        return requester
            .post("/api/users/add/", `lyst_id=${lystId}`)
            .then(() => {
                setFollowing(true);
                analytics.event("Follow Button", "Follow - Success", undefined, true);
            })
            .catch(() => {
                analytics.event("Follow Button", "Follow - Error", undefined, true);
            });
    }

    function unFollow(): Promise<void> {
        return requester
            .post("/api/users/remove/", `lyst_id=${lystId}`)
            .then(() => {
                setFollowing(false);
                analytics.event("Follow Button", "Unfollow - Success", undefined, true);
            })
            .catch(() => {
                analytics.event("Follow Button", "Unfollow - Error", undefined, true);
            });
    }

    const branchOnClick = useClickTracker(
        "get_updates_designer",
        "send_to_app",
        "get_updates_button"
    );
    const pageSubType = environment.get("pageSubType");
    let buttonLabel = following ? followedText : notFollowedText;
    let branchHref;
    let onClick;
    if (
        pageSubType &&
        pageSubType.startsWith("designer") &&
        isAuthenticated === "false" &&
        isIos &&
        environment.getFeature("mg_du_banner_ios_to_app")
    ) {
        const branchReferralLink = new URL(BranchLink.DesignerUpdates);
        const branchIOLinkData: BranchIOLinkData = getLinkData();
        for (const branchDataProperty in branchIOLinkData) {
            branchReferralLink.searchParams.set(
                branchDataProperty,
                branchIOLinkData[branchDataProperty]
            );
        }

        branchHref = branchReferralLink.toString();
        onClick = branchOnClick;
    } else {
        const [category, action, label] = analyticsParameters;

        onClick = (): void => {
            analytics.event(category, action, label);
            if (isAuthenticated === "false") {
                openCustomerCaptureOverlay({
                    designerId: lystId,
                    registrationReason: registrationReason,
                    captureType: "signup_du",
                });
            } else if (following) {
                unFollow();
            } else {
                follow();
            }
        };
    }

    return (
        <Button
            styleType="primary"
            className={className}
            onClick={onClick}
            disabled={false}
            fullWidth={false}
            fullHeight={false}
            openInNewTab={false}
            href={branchHref}
        >
            {buttonLabel}
        </Button>
    );
}

export default connect(null, { openCustomerCaptureOverlay })(FollowDesignerButton);
